import paths from '@app/src/wf-constants/paths'
import { Inbox, InboxOutlined } from '@mui/icons-material'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import NavigationMenuItem from '../VerticalMenu/NavigationItems/NavigationMenuItem'

const PlatformReleasesMenuItem: React.FC = () => {
  const { formatMessage } = useIntl()
  const { productRelease } = useFlags()

  if (!productRelease) return null

  return (
    <NavigationMenuItem
      path={paths.platformReleases}
      title={formatMessage({ id: 'navbar.platformReleases' })}
      icon={InboxOutlined}
      iconSelected={Inbox}
    />
  )
}

export default PlatformReleasesMenuItem
